import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../assets/css/student/blogs/BlogTitle.css';
// AboutUs.js

import { Container } from "react-bootstrap";
 // ✅ Link your CSS for styling

const AboutUs = () => {
  return (
    <section className="Blog-main-section">
      {/* Top Banner */}
      <div className="Blog-banner">
        <Container>
          <div className="banner-inner">
            <h1 className="banner-heading">
              <span className="orange-highlight">OUR STORIES</span> 
            </h1>
            <p className="banner-text">
             We strive to make education accessible to all, supporting students with fees, uniforms, and books so every child can reach their full potential
            </p>
          </div>
        </Container>
      </div>
    </section>
  );
};

export default AboutUs;
